module.exports = __webpack_public_path__ + "static/media/tuition-and-fees.edd3d9c2.svg";